export default "__VITE_ASSET__f9e5184f__"